import React, { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * Description of the contents of a cart match offer
 */
class CartMatchDescription extends Component {

    getDescriptionFromDetail = detail => {
        let priceLevel = null;
        this.props.priceLevels.forEach(pl => {
            if (+pl.price_level_id === +detail.id) {
                priceLevel = pl;
            }
        });
        if (!priceLevel || typeof priceLevel !== 'object') {
            return null;
        }
        return `${+detail.count} x ${priceLevel.name}`;
    }

    getFullDescription = () => {
        const descriptions = [];
        this.props.details.forEach(detail => {
            const desc = this.getDescriptionFromDetail(detail);
            if (desc) {
                descriptions.push(desc);
            }
        });
        return descriptions.join(', ');
    }

    render() {
        return this.getFullDescription();
    }
}

CartMatchDescription.propTypes = {
    details: PropTypes.array.isRequired,
    priceLevels: PropTypes.array.isRequired,
};

export default CartMatchDescription;
